import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Spin from 'components/Spin';
import useAlert from 'hooks/useAlert';
import usePromise from 'hooks/usePromise';
import React from 'react';
import { getMediaUrl } from 'services/media';
import { prettyFileSize, toUserTimezone } from 'utils';
import FileActions from './FileActions';

const FileItem = ({
  file,
  account,
  onFileSelect,
  onDelete,
  onMove,
  onRename,
  checked,
  onCheck,
}) => {
  const alert = useAlert();
  const [loading, handler] = usePromise(() => {
    return getMediaUrl(file.location).then((resp) => {
      window.open(resp, '_blank');
    });
  });
  const onDownload = (e) => {
    e.preventDefault();
    if (onFileSelect) {
      onFileSelect(file);
    } else {
      handler();
    }
  };

  const handleDelete = () => {
    return onDelete(file);
  };

  const handleMove = () => {
    return onMove(file);
  };

  const handleRename = async () => {
    await alert.prompt({
      inputValue: file.file_name,
      title: 'Enter file name',
      onConfirm: (value) => onRename(file, value),
    });
  };

  return (
    <Spin spinning={loading}>
      <ListItem dense button>
        {onCheck && (
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={checked}
              disableRipple
              onChange={(e) => onCheck(e.target.checked, file)}
            />
          </ListItemIcon>
        )}
        <ListItemText
          disableTypography
          primary={
            <Box display="flex" pr={6}>
              <Typography component={Box} flex={1} sx={{ cursor: 'pointer' }}>
                {file.file_name}
              </Typography>
              <Typography component={Box} mr={4}>
                {toUserTimezone(
                  file.created_at,
                  account.account_timezone,
                ).format('LLL')}
              </Typography>
              <Typography component={Box} width={100} align="right" pr={3}>
                {file.file_size !== '-1' ? prettyFileSize(file.file_size) : '-'}
              </Typography>
            </Box>
          }
          onClick={onDownload}
        />
        <ListItemSecondaryAction>
          <FileActions
            onDelete={handleDelete}
            onMove={handleMove}
            onRename={handleRename}
            onOpen={handler}
          />
        </ListItemSecondaryAction>
      </ListItem>
    </Spin>
  );
};

export default FileItem;
